<template>
    <div class="page">
      <head-public title="我的志愿表"></head-public>
      <div style="margin-top:46px">
       <div v-if="isHave" class='card' v-for="(item,index) in volunteer" :key="index">
        <div class='content-card'>
            <!-- logo -->
            <div class='content-card-logo'>
                <img :src='item.logo' />
            </div>
            <!-- logo end -->
            <!-- 中间文字 -->
            <div class='content-card-center'>
                <!-- <div class='content-card-center-title'>{{item.school_name}}</div> -->
                <div class='content-card-center-type'>
                    <div>{{item.school_name}}</div>
                    <div>排名:{{item.ranking}}</div>
                    <!-- <div></div> -->
                </div>
                <div class='content-card-center-foot'>
                    <div style="display:flex">
                        <div>招生计划:{{item.plan_points}}</div>
                        <div class='pl'>最低分:{{item.min_score}}</div>
                    </div>
                    <div style="display:flex">
                        <div>最低次位:{{item.low_sort}}</div>
                        <div class='pl'>录取人数:{{item.enter_num}}</div>
                    </div>
                </div>
            </div>
            <!-- 概率 -->
            <div class='pro-number'>{{item.probability}}%</div>
            <!-- 小箭头 -->
            <div class='right-logo'>
                <div class='addBi'>{{index}}</div>
                <div class='majorNum'>
                    <van-icon name="arrow" :class='["font_family" ,"icon-xiahua" ,"jiantou",uhide==item.id?"":"dis-none"]' @click="clickShow(item.sid)" />
                     <van-icon name="arrow-down" :class='["font_family" ,"icon-youhua" ,"jiantou" ,uhide==item.id?"dis-none":""]' @click="clickShow(item.sid)" />          
                    <div>专业({{item.career_list.length}})</div>
                </div>
            </div>
        </div>
        <!-- 隐藏部分 -->
        <div :class='["hiden",uhide==item.sid?"":"dis-none"]'>
            <div class='hiden-box' v-for="(major,index) in item.career_list" :key="index">
                <div class='hiden-left'>
                    <div class='hiden-box-title'>{{major.name}}</div>
                    <div class='content-card-center-foot2'>
                        <div style="display:flex">
                            <div>招生计划:{{major.plan_num}}</div>
                            <div class='pl'>最低分:{{major.min_score}}</div>
                        </div>
                        <div style="display:flex">
                            <div>最低位次:{{major.min_sort}}</div>
                            <div class='pl'>录取人数:{{major.enter_num}}</div>
                        </div>
                    </div>
                </div>
                <div class='pro-number2'>{{major.probability}}%</div>
            </div>
        </div>
       </div> 
    </div>
    <div v-if="!isHave" class="back" >
        <div class="tips">暂无志愿</div>
    </div>
    </div>
</template>
<script>
import { httpPost } from "../../axios/index";
import headPublic from "../../components/publicHead"
import { constants } from 'crypto';
export default {
    data(){
        return{
                 uhide: 0,
                volunteer: [],
                empty: '志愿表生成中，请稍后...',
                isHave: false,
        }
    },
    methods:{
        // 点击展开专业
        clickShow(e){
          
             var toggleBtnVal = this.uhide;
            if (toggleBtnVal == e) {   
                this.uhide= 0
            } else {
                this.uhide=e
    }
        },
        // 获取我的志愿单数据
       fetchData() {
            httpPost("/user/volunteer_list",{
                  uid: this.$store.state.userInfo.user_id
            }).then(res=> {
               
                if (res.code === 1) {
                     this.volunteer=res.volunteer_list,
                     this.isHave= true
                }
            });
        }
    },
    mounted(){
        this.fetchData();
    },
    components:{
        headPublic
    }
}
</script>
<style scoped>
   .page{
    background: #f6f9fa;
}
.card {
  background: #fff;
  box-shadow: 0rem 0rem 0.125rem #ddd;
  width: 95%;
  margin: 0.625rem auto;
}

.content-card {
  display: flex;
  background: #fff;
  padding: 0.9375rem;
  padding-right: 0;
}

.content-card-logo {
  width: 3.4375rem;
  height: 3.4375rem;
  margin-top: 0.9375rem;
}

.content-card-logo img {
  width: 100%;
  height: 100%;
}

.content-card-center {
  padding-left: 0.3125rem;
  width: 50%;
}

.content-card-center-title {
  font-family: PingFang-SC-Regular;
  font-size: 1.0625rem;
  color: #4d4d4d;
}

.content-card-center-type {
  font-family: PingFang-SC-Regular;
  font-size: 0.875rem;
  color: #878787;
}

.content-card-center-type text:first-child {
  padding: 0;
}

.content-card-center-type text {
  padding-left: 0.3125rem;
}

.content-card-center-foot {
  font-family: PingFang-SC-Regular;
  font-size: 0.75rem;
  color: #878787;
  padding-top: 0.3125rem;
  padding-right: 0.3125rem;
}

.content-card-center-foot text {
  padding-left: 0.1875rem;
}

.content-card-center-foot text:first-child {
  padding: 0;
}

.pro-number {
  font-size:1.0625rem;
  color: #22d9d9;
  line-height: 4;
  margin-right: 0.625rem;
}

.right-logo {
  font-size: 0.75rem;
  text-align: center;
  color: #878787;
  position: relative;
}

.addBi{
  width: 1.875rem;
  height: 2.0625rem;
  color: #fff;
  font-size: 0.75rem;
  line-height: 2.0625rem;
  background: #24d5ab;
  border-bottom-left-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
  position:absolute;
  top:-0.9375rem;
  left: 0.3125rem;
}

.majorNum{
  /* line-height: 58rpx; */
  font-size: 0.75rem;
}

.jiantou {
  font-size: 0.9375rem;
  color: #e0e0e0;
  padding-top:1.875rem;
  padding-bottom: 0.625rem;
}

.pl {
  padding-left: 0.5rem !important;
}

.p2 {
  color: #333;
}
.p3{
  padding-left: 0.3125rem;
}
.hiden-box {
  width: 90%;
  margin: 0 auto;
  border-top: 0.0625rem solid #e4e9ed;
  padding: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hiden-left{
  width: 69%;
}
.content-card-center-foot2 {
  font-size:0.75rem;
  color: #878787;
  padding-top: 0.3125rem;
}
.hiden-box-title{
   font-size: 1rem;
   color: #4d4d4d;
}

.pro-number2 {
  font-size: 1.0625rem;
  color: #22d9d9;
  line-height: 4;
  margin: 0 0.3125rem;
}

.dis-none {
  display: none;
}

.hide{
 display: none !important;
}
.show{ 
 display: block !important;
}
.back{
    position: relative;
    width:100vw;
    height:90vh;
}
.tips{
    position: absolute;
    top:3.125rem;
    left: 9.3125rem;
    color: #828d9c;
    text-align: center;
}
</style>

